<template>
  <div class="row">
    <div class="col-12">
      <div class="row">
        <div class="col-12">
          <div class="col-12 col-lg-8 px-0">
            <accreditations-list ref="accreditations" :coverage="coverage" :showLeadTypesButton="false" @loaded="busy = false" />
          </div>
        </div>
        <spinner v-if="busy" :display-loading="true" />
      </div>
    </div>
  </div>
</template>

<script>
import Spinner from "@/components/animation/Spinner";
import AccreditationsList from '@/components/list/AccreditationsList';
import notification from "@/imports/mixins/notification";

export default {
  name: "Accreditations",
  components: {Spinner, AccreditationsList},
  mixins: [notification],
  props: ['coverage'],
  data: function() {
    return {
      busy: true,
      disableSave: true,
    }
  },
  methods: {
    save() {
      this.$refs.accreditations.onSubmit().then(() => {
        this.$store.dispatch('updateGlobals');
        this.$emit('complete');
        this.saveNotification();
        this.disableSave = true;
        this.$emit('isSaving', true);
      });
    },
    saveDisabled: function(accredsEmpty) {
      this.disableSave = this.busy || accredsEmpty;
    },
    saveNotification: function() {
      this.notify(
        this.$bvToast,
        `Accreditations saved`,
        null,
        'success'
      );
    }
  },
  watch: {
    disableSave: function(value) {
      this.$emit('clean', value);
    }
  },
  mounted: function() {
    this.$watch(
      "$refs.accreditations.empty",
      (new_value) => {
        this.saveDisabled(new_value);
      }
    );
    this.$emit('clean', true);
  },
}
</script>

<style scoped>

</style>
